import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "store";
import { setUser } from "store/auth/userSlice";
import { apiGetMyProfile } from "services/UserService";

/**
 * Oturum açıkken WhoAmI ile profili senkronize eder.
 * Login yanıtında address gelmeyen veya eski persist oturumları için Redux'u günceller.
 */
const UserProfileSync = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth?.session?.token);
  const signedIn = useSelector((state) => state.auth?.session?.signedIn);

  useEffect(() => {
    if (!token || !signedIn) {
      return;
    }

    let cancelled = false;

    const syncProfile = async () => {
      try {
        const response = await apiGetMyProfile();
        if (cancelled) {
          return;
        }

        const profile = response?.data?.data;
        if (!profile) {
          return;
        }

        const currentUser = store.getState().auth?.user;

        dispatch(
          setUser({
            ...(currentUser || {}),
            userName: profile.fullname ?? currentUser?.userName ?? "",
            email: profile.email ?? currentUser?.email ?? "",
            phone: profile.phone ?? currentUser?.phone ?? "",
            address: profile.address ?? "",
          }),
        );
      } catch {
        // Profil senkronu sessizce atlanır; uygulama akışı devam eder.
      }
    };

    syncProfile();

    return () => {
      cancelled = true;
    };
  }, [token, signedIn, dispatch]);

  return null;
};

export default UserProfileSync;
